import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import {path} from 'ramda';

import { types as sdkTypes } from '../../util/sdkLoader';
import {
  confirmManualPaymentMultiBookingError,
  confirmManualPaymentMultiBookingRequest, confirmManualPaymentMultiBookingSuccess,
  fetchMessages,
  fetchNextTransitions,
  fetchTransaction,
  setInitialValues,
} from '../../ducks/transaction.duck';
import { queryOwnListings } from '../../ducks/ownListings.duck';
import {
  stripeCustomer
} from '../AccountPaymentsPage/components/PaymentMethodsTab/PaymentMethodsTab.duck';
import {
  TRANSITION_CONFIRM_PAYMENT,
  TRANSITION_CONFIRM_PAYMENT_AFTER_PRE_ACCEPTED,
  TRANSITION_REQUEST_MANUAL_PAYMENT,
  TRANSITION_REQUEST_MULTI_BOOKING, TRANSITION_REQUEST_RETRY_MANUAL_PAYMENT,
} from '../../util/transactions';
import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { confirmCardPayment, retrievePaymentIntent } from '../../ducks/stripe.duck';
import {
  CONFIRM_PAYMENT_ERROR,
  CONFIRM_PAYMENT_REQUEST,
  CONFIRM_PAYMENT_SUCCESS,
} from '../CheckoutPage/CheckoutPage.duck';
import { STRIPE_PI_USER_ACTIONS_DONE_STATUSES } from '../CheckoutPage/CheckoutPage';
import {updateProfile} from "../ProfileSettingsPage/ProfileSettingsPage.duck";
import {sendDeclineBookingsOnSameTimeslot} from "../../util/bookingsHelpers";

const { UUID } = sdkTypes;

const isNonEmpty = value => {
  return typeof value === 'object' || Array.isArray(value) ? !isEmpty(value) : !!value;
};


export const confirmManualPayment = params => (dispatch, getState, sdk) => {
  dispatch(confirmManualPaymentMultiBookingRequest());
  const requestRetryManualPaymentBodyParams = {
    id: params.transactionId,
    transition: TRANSITION_REQUEST_RETRY_MANUAL_PAYMENT,
    params: {},
  };
  const requestManualPaymentBodyParams = {
    id: params.transactionId,
    transition: TRANSITION_REQUEST_MANUAL_PAYMENT,
    params: {},
  };
  const confirmManualPaymentBodyParams = {
    id: params.transactionId,
    transition: TRANSITION_CONFIRM_PAYMENT_AFTER_PRE_ACCEPTED,
    params: {},
  };
  const initialStripePaymentIntentClientSecret = path(['order', 'attributes', 'protectedData', 'stripePaymentIntents', 'default', 'stripePaymentIntentClientSecret'], params);
  const lastTransition = path(['order', 'attributes', 'lastTransition'], params);
  const canRetryManualPayment = lastTransition === TRANSITION_REQUEST_MANUAL_PAYMENT;
  // const retryManualPaymentMaybe = lastTransition === TRANSITION_REQUEST_MANUAL_PAYMENT ?
  //   sdk.transactions
  //     .transition(requestRetryManualPaymentBodyParams, { expand: true }) :
  //   Promise.resolve();
  const startManualPaymentMaybe = async () => {
    return !canRetryManualPayment ?
      sdk.transactions
        .transition(requestManualPaymentBodyParams, { expand: true }) :
      {data: {data: params.order}};
  }
  console.log('confirmManualPayment', params, startManualPaymentMaybe);

  // return retryManualPaymentMaybe.then(() => {
  //   return sdk.transactions
  //     .transition(requestManualPaymentBodyParams, { expand: true })
  // })
  return startManualPaymentMaybe()
    .then(async (response) => {
      const {stripe, paymentParams, transactionId} = params;
      if (initialStripePaymentIntentClientSecret) {
        const { paymentIntent } = await dispatch(retrievePaymentIntent({ stripe, stripePaymentIntentClientSecret: initialStripePaymentIntentClientSecret }));
        const hasPaymentIntentUserActionsDone =
          paymentIntent && STRIPE_PI_USER_ACTIONS_DONE_STATUSES.includes(paymentIntent.status);
        console.log('paymentIntentResponse', hasPaymentIntentUserActionsDone, paymentIntent);
        if (hasPaymentIntentUserActionsDone) return {};
      }
      const order = response.data.data;
      // const {order} = params;
      const stripePaymentIntentClientSecret = path(['attributes', 'protectedData', 'stripePaymentIntents', 'default', 'stripePaymentIntentClientSecret'], order);
      console.log('requestManualPaymentBodyParams',
        { orderId: transactionId, stripe, paymentParams, stripePaymentIntentClientSecret },
        response,)
      return dispatch(confirmCardPayment( { orderId: transactionId, stripe, paymentParams, stripePaymentIntentClientSecret }));
    })
    .then(response => {
      console.log('response', response)
      return sdk.transactions
        .transition(confirmManualPaymentBodyParams, { expand: true })
    })
    .then(response => {
      const order = response.data.data;
      dispatch(confirmManualPaymentMultiBookingSuccess(order.id));
      // sendDeclineBookingsOnSameTimeslot(params.transactionId.uuid, true);
      dispatch(fetchTransaction(params.transactionId));
      dispatch(updateProfile({
        publicData: {
          paymentMethodVerified: true,
        },
      }));
      return order;
    })
    .catch(e => {
      dispatch(confirmManualPaymentMultiBookingError(storableError(e)));
      const transactionIdMaybe = params.transactionId
        ? { transactionId: params.transactionId.uuid }
        : {};
      log.error(e, 'manual-payment-multi-booking-order-failed', {
        ...transactionIdMaybe,
      });
      dispatch(fetchTransaction(params.transactionId));
    });
};


// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const loadData = params => (dispatch, getState) => {
  const txId = new UUID(params.id);
  const state = getState().transaction;
  const txRef = state.transactionRef;
  const txRole = params.transactionRole;

  // In case a transaction reference is found from a previous
  // data load -> clear the state. Otherwise keep the non-null
  // and non-empty values which may have been set from a previous page.
  const initialValues = txRef ? {} : pickBy(state, isNonEmpty);
  dispatch(setInitialValues(initialValues));

  // Sale / order (i.e. transaction entity in API)
  return Promise.all([
    dispatch(fetchTransaction(txId, txRole, true)),
    dispatch(fetchMessages(txId, 1)),
    dispatch(fetchNextTransitions(txId)),
    dispatch(queryOwnListings({})),
    dispatch(stripeCustomer()),
  ]);
};
